import { IonContent, IonPage, IonButton } from '@ionic/react'
import React, { useState, useEffect } from 'react'
import './SignUp.css'
import Input from '../components/Input'
import Toast, { ToastProps } from '../components/Toast'
import { useHistory } from 'react-router'
import { UserIcon, PassShowIcon, PassHideIcon } from '../conf/images'
import { signup } from '../service/api/user'
import { Local_User_Key } from '../redux/reducers/user'
import { isPhoneNumber } from '../utils'
import { SigninPage } from '../conf/routePath'

const Logo = () => <img className='logo' src={UserIcon} alt='icon' />

interface FormModel {
    username: string
    password: string
    rePassword: string
}
interface SiginFormProps {
    value: FormModel
    onChange?: (value: FormModel) => void
}
const SignupForm: React.FC<SiginFormProps> = (props) => {
    const { value, onChange = (value: {}) => undefined } = props
    const [passShow, setPassShow] = useState(false)
    const [rePassShow, setRePassShow] = useState(false)
    return (
        <div className='signup-form'>
            <Input
                type='text'
                className='input username'
                value={value.username}
                onChange={(val) => {
                    onChange({
                        ...value,
                        username: val,
                    })
                }}
                placeholder='请输入手机号'
            />
            <Input
                type={passShow ? 'text' : 'password'}
                className='input password'
                value={value.password}
                onChange={(val) =>
                    onChange({
                        ...value,
                        password: val,
                    })
                }
                suffix={
                    <img
                        className='pass-switch'
                        onClick={() => setPassShow(!passShow)}
                        src={passShow ? PassHideIcon : PassShowIcon}
                        alt='icon'
                    />
                }
                placeholder='请输入6-16位密码'
            />
            <Input
                type={rePassShow ? 'text' : 'password'}
                className='input password'
                value={value.rePassword}
                onChange={(val) =>
                    onChange({
                        ...value,
                        rePassword: val,
                    })
                }
                suffix={
                    <img
                        className='pass-switch'
                        onClick={() => setRePassShow(!rePassShow)}
                        src={rePassShow ? PassHideIcon : PassShowIcon}
                        alt='icon'
                    />
                }
                placeholder='请再次确认密码'
            />
        </div>
    )
}

const SignUp: React.FC = () => {
    const history = useHistory()
    const [formdata, setFormdata] = useState<FormModel>({
        username: '',
        password: '',
        rePassword: '',
    })
    const [toastOptions, setToastToastOptions] = useState<ToastProps>({
        isOpen: false,
        message: '',
        color: 'error',
        duration: 1500,
    })
    const [formdataValid, setFormdataValid] = useState(false)
    const [signupLoading, setSignupLoading] = useState(false)
    useEffect(() => {
        localStorage.removeItem(Local_User_Key)
    }, [])
    useEffect(() => {
        /** 验证表单输入是否有效 */
        const checkFormDataValid = () => {
            let usernameTrim = formdata.username.trim()
            let passwordTrim = formdata.password.trim()
            let rePasswordTrim = formdata.rePassword.trim()
            let valid = !!(usernameTrim && passwordTrim && rePasswordTrim)
            return valid
        }
        setFormdataValid(checkFormDataValid())
    }, [formdata])
    /** 登录 */
    const handleSignUp = async () => {
        if (!formdataValid) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: '请补全注册信息',
            })
            return
        }
        if (!isPhoneNumber(formdata.username)) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: '手机号格式不合法',
            })
            return
        }
        if (formdata.password !== formdata.rePassword) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: '两次密码输入不一致',
            })
            return
        }
        try {
            setSignupLoading(true)
            let res = await signup({
                username: formdata.username,
                password: formdata.password,
                nickname: formdata.username,
            })
            console.log(res)
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'success',
                message: '注册成功',
            })
        } catch (error) {
            if (error.status && error.status === 401) {
                setToastToastOptions({
                    ...toastOptions,
                    isOpen: true,
                    color: 'error',
                    message: '权限不足，注册失败',
                })
                return
            }
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                position: 'top',
                color: 'error',
                message: error.message,
            })
        }
        setSignupLoading(false)
    }
    return (
        <IonPage className='signup-page'>
            <IonContent className='content' scrollY={false}>
                <Logo />
                <SignupForm
                    value={formdata}
                    onChange={(val) => {
                        setFormdata(val)
                    }}
                />
                <IonButton
                    disabled={!formdataValid || signupLoading}
                    color='primary'
                    className='signup-button'
                    onClick={handleSignUp}
                >
                    注册
                </IonButton>
                <p
                    className='signin-tip'
                    onClick={() => history.replace(SigninPage)}
                >
                    已有账号，立即登录
                </p>
                <Toast
                    {...toastOptions}
                    onClose={() =>
                        setToastToastOptions({ ...toastOptions, isOpen: false })
                    }
                />
            </IonContent>
        </IonPage>
    )
}

export default SignUp
